import React from "react";
import {Alert, Box, Button, Typography} from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import {useTranslation} from "react-i18next";
import EffectChip from "./data-source-catalog/effect-chip";
import RequirementCallout from "./data-source-catalog/requirement-callout";

const SelectedDataSourceSummary = ({
                                       entry,
                                       onChange,
                                       showMultiselectTechnicalImportWarning = false,
                                   }) => {
    const {t} = useTranslation('views', {keyPrefix: 'app-specific.settingsImport.dataSourceCatalog'});

    if (!entry) {
        return null;
    }

    return (
        <Box sx={{width: '100%'}}>
            <Box
                sx={{
                    mx: {xs: 2, md: 5},
                    mb: 2,
                    p: 2,
                    borderRadius: 1,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    display: 'flex',
                    flexDirection: {xs: 'column', sm: 'row'},
                    alignItems: {xs: 'stretch', sm: 'flex-start'},
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                <Box sx={{minWidth: 0, flex: 1}}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: {xs: 'column', sm: 'row'},
                            alignItems: {xs: 'stretch', sm: 'flex-start'},
                            justifyContent: 'space-between',
                            gap: 1.5,
                        }}
                    >
                        <Typography variant="subtitle1" fontWeight={600}>
                            {entry.title}
                        </Typography>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<SwapHorizIcon />}
                            onClick={onChange}
                            sx={{
                                flexShrink: 0,
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: 1,
                                alignSelf: {xs: 'stretch', sm: 'flex-start'},
                            }}
                        >
                            {t('changeDataset')}
                        </Button>
                    </Box>
                    {entry.description && (
                        <Typography variant="body2" color="text.secondary" sx={{mt: 0.25, lineHeight: 1.5}}>
                            {entry.description}
                        </Typography>
                    )}
                    {entry.detail && (
                        <Typography variant="body2" color="text.secondary" sx={{mt: 1, lineHeight: 1.6}}>
                            {entry.detail}
                        </Typography>
                    )}
                    {entry.effect && (
                        <Box sx={{mt: 1}}>
                            <EffectChip effect={entry.effect} />
                        </Box>
                    )}
                    <RequirementCallout rules={entry.requirementRules} />
                    {entry.alerts?.map((alert) => (
                        <Alert
                            key={alert.message}
                            severity={alert.severity ?? 'info'}
                            variant="outlined"
                            sx={{mt: 1.5, borderRadius: 1}}
                        >
                            {alert.message}
                        </Alert>
                    ))}
                    {showMultiselectTechnicalImportWarning && (
                        <Alert severity="warning" variant="outlined" sx={{mt: 1.5, borderRadius: 1}}>
                            {t('alerts.multiselectNotSupported')}
                        </Alert>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default SelectedDataSourceSummary;
